import styled from 'styled-components/macro'
import { ReactComponent as Icon } from '../../Icons/icon-chevron.svg'
import { em } from '../../../utils/styles'

const SelectIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: ${em(24)};
  width: ${em(8.5)};
  height: ${em(14)};
  transform: translateY(-50%) rotate(90deg);
  pointer-events: none;
`

export default SelectIcon
